import { connect } from "react-redux";
import ViewRmTicket from "./viewRmTicket";
import { bindActionCreators } from "redux";
import {
  fetchRmTicketDetails,
  postUpdateRMStatus,
  postTicketAssignment,
  postRmRemark,
  fetchRmTicketStatus
} from "services/redux/maintenance/rmTicket/action";
import { documentUploadUrl } from "services/redux/fileUpload/action";

const mapStateToProps = (state) => ({
  pmTicket: state.pmTicketReducer.pmTicket,
  rmTicketDetails: state.rmTicketReducer.rmTicketDetails,
  rmStatus: state.rmTicketReducer.rmStatus,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      postUpdateRMStatus,
      documentUploadUrl,
      postRmRemark,
      fetchRmTicketStatus,
      fetchRmTicketDetails,
      postTicketAssignment
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ViewRmTicket);
